<section
  class="p-0 flex flex-col gap-6"
  *ngrxLet="selectedDownload$ as selectedDownload"
>
  @if (isLoggedIn$ | ngrxPush) {
    <section class="p-0" aria-labelledby="page-headline">
      <h1 id="page-headline" class="mu-heading-5 text-petrol-650 pb-2">
        Information zur Basis-Software
      </h1>
      <p>Hier finden Sie folgende Downloads:</p>
      <ul class="list-inside list-disc pl-3">
        <li>
          DATEV Basis-Installer für
          <ul class="list-inside list-disc pl-6">
            <li>eine Neuinstallation der DATEV-Programme für Berater</li>
            <li>eine Neuinstallation der DATEV-Programme für Unternehmen</li>
            <li>Reparatur der DATEV-Plattform</li>
          </ul>
        </li>
        <li>Datenträger der DATEV-Programme als ISO-Dateien</li>
      </ul>
    </section>

    <mat-divider aria-hidden="true"></mat-divider>
    @if ((mainComponents$ | ngrxPush) !== '') {
      <dp-downloads-table
        [dataSource]="packageDatasource"
        [tableAriaLabel]="'Aktuelle Downloads Basis-Software'"
        [selectedDownload]="selectedDownload"
        [showLoadMoreButton]="!allDataLoaded"
        (onRowSelection)="handleTableRowSelection($event)"
        (onLoadMoreButtonClick)="loadMorePackages()"
        (onErrorReloadButtonClick)="reloadSite()"
        [displayedColumns]="['name', 'version', 'published_date']"
      ></dp-downloads-table>

      <dackl-expansion-panel displayMode="light" headline="Archiv">
        <dp-downloads-table
          [dataSource]="archiveDatasource"
          [tableAriaLabel]="'Archiv Downloads Basis-Software'"
          [selectedDownload]="selectedDownload"
          [showLoadMoreButton]="!allArchiveDataLoaded"
          (onRowSelection)="handleTableRowSelection($event)"
          (onLoadMoreButtonClick)="loadMoreArchivedPackages()"
          (onErrorReloadButtonClick)="reloadSite()"
          [displayedColumns]="['name', 'version', 'published_date']"
        ></dp-downloads-table>
      </dackl-expansion-panel>
    } @else {
      <dackl-empty-state image="no-matches" size="XS">
        <h2 class="heading-3 mb-2">Keine Daten vorhanden</h2>
        <p class="text-center">Keine Downloads gefunden.</p>
      </dackl-empty-state>
    }
  } @else {
    <dp-logged-out-state></dp-logged-out-state>
  }
</section>
